import { Button, Card, CardContent, Chip, Divider, Grid, Tooltip, Typography, TextField, Select, MenuItem, InputAdornment, IconButton, Stack, Table, TableHead, TableRow, TableCell, TableBody, Paper, FormControl, InputLabel, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import searchIcon from "../../icons/searchIcon.svg"
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import React, { useState, useEffect, useContext } from "react";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CloseIcon from "@mui/icons-material/Close";
import * as XLSX from "xlsx";
import styled from "styled-components";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Box from "@mui/material/Box";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridDensitySelector, getGridStringOperators, } from "@mui/x-data-grid";
import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import { Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, Send, Search } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import "../../App.css";
import closeIcon from "../../icons/CloseIcon.svg"
import AddOlympiadSchoolModal from "../../components/modals/AddOlympiadSchoolModal";
import SelectionPaymentOlympiad from "../../components/SelectionPaymentOlympiad";
import VerifyPaymentOlympiadRegistrationModal from "../../components/VerifyPaymentOlympiadRegistrationModal";
import ViewOlympiadRegistrationModal from "../../components/ViewOlympiadRegistrationModal";
import OlympiadShipmentModal from "../../components/OlympiadShipmentModal";
import BulkOlympiadTransaction from "../../components/modals/BulkOlympiadTransaction";
import OlympiadDeliverModal from "../../components/OlympiadDeliverModal";
import OlympiadItemDeliverModal from "../../components/OlympiadDeliverItemModal";
import AddSoOlympiad from "../../components/AddSoOlympiad";
import AddInvoiceOlympiad from "../../components/AddInvoiceOlympiad";
import AddSetOffOlympiad from "../../components/AddSetOfOlympiad";
import ViewInvoiceOlympiad from "../../components/ViewInvoiceOlympiad";
import ViewToVerifySoOlympiad from "../../components/ViewToVerifySOOlympiad";
import ViewToVerifyInvoiceOlympiad from "../../components/ViewToVerifyInvoiceOlympiad";
import { useNavigate } from "react-router-dom";
import BulkAddSoBoOlympiad from "../../components/modals/BulkAddSoBoOlympiad";
import BulkAddInvoiceOlympiad from "../../components/modals/BulkAddInvoiceOlympiad";
import BulkAddMainRegistration from "../../components/modals/BulkAddMainRegistrationOlympiad";
import AddInvoiceOlympiadRC from "../../components/AddInvoiceOlympiadRC";
import AddInvoiceOlympiadSM from "../../components/AddInvoiceOlympiadSM";
import ViewToVerifyInvoiceOlympiadRC from "../../components/ViewToVerifyInvoiceOlympiadRC";
import ViewToVerifyInvoiceOlympiadSM from "../../components/ViewToVerifyInvoiceOlympiadSM";
import ViewSoImageModal from "../../components/ViewSoImageModal";
import ViewSMInvoiceImageModal from "../../components/ViewSMInvoiceImageModal";
import ViewRCInvoiceImageModal from "../../components/ViewRCInvoiceImageModal";
import BulkAddInvoiceOlympiadRC from "../../components/modals/BulkAddInvoiceOlympiadRC";
import BulkAddInvoiceOlympiadSM from "../../components/modals/BulkAddInvoiceOlympiadSM";

const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
    `
      position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;
const TableContainer = styled.div`
  //   height: calc(
  //     100vh - ${isMobile
        ? "56px - 20px - 82.23px"
        : "128px - 29px - 50.77px"}
  //   );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  //   border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;
  ${isMobile &&
    `
    flex-direction: column;
  `}
`;
const TabsContainer = styled.div`
  ${isMobile &&
    `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;

// +--------+-----------------+
// | Status | Name            |
// +--------+-----------------+
// | 0      | Pending         |
// | 1      | Approved        |
// | 2      | Verify          |
// | 3      | Ship            |
// | 4      | Delivery        |
// | 5      | All             |
// | 6      | Reject          |
// | 7      | Delete          |
// | 8      | Partial Deliver |
// | 9      | Hold            |
// | 10     | Rm Remark       |
// | 11     | Shipment Ready  |
// +--------+-----------------+

const OlympiadRegistration = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
    const [rowCount, setRowCount] = useState();
    const [newRows, setNewRows] = useState([])
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [search, setSearch] = useState("")
    const [visibleEmployees, setVisibleEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false)
    const [accessChanges, setAccessChanges] = useState([]);
    const [pageSize, setPageSize] = useState(20)
    const [accessModulesData, setAccessModulesData] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [newOrderStatus, setNewOrderStatus] = useState(0);
    const [automationStatus, setAutomationStatus] = useState("")
    const [filteredDate, setFilteredData] = useState({});
    const [modalData, setModalData] = useState([])
    const [openViewModal, setOpenViewModal] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModalData, setEditModalData] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [status, statusData] = useState(null);
    const [rejectModal, setRejectModal] = useState(false);
    const [rejectRemark, setRejectRemark] = useState("");
    const [approveModal, setApproveModal] = useState(false);
    const [openModalWhenVerify, setOpenModalWhenVerify] = useState(false);
    const [approveModalHold, setApproveModalHold] = useState(false);
    const [approveRemark, setApproveRemark] = useState("");
    const [approveRemarkHold, setApproveRemarkHold] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);
    const [updatePaymentModal, setUpdatePaymentModal] = useState(false);
    const [editModalDataNew, setEditModalDataNew] = useState(null)
    const [verifyPaymentModal, setVerifyPaymentModal] = useState(false);
    const [verifyPaymentModalData, setVerifyPaymentModalData] = useState([])
    const [viewOlympiadModalData, setViewOlympiadModalData] = useState([])
    const [shipmentModal, setShipmentModal] = useState(false);
    const [shipmentModalData, setShipmentModalData] = useState([])
    const [deliverModal, setDeliverModal] = useState(false);
    const [deliverModalData, setDeliverModalData] = useState([])
    const [itemDeliverModal, setItemDeliverModal] = useState(false);
    const [itemDeliverModalData, setItemDeliverModalData] = useState([])
    const [bulkSchool, setBulkSchool] = useState(false);
    const [bulkSoBoModal, setBulkSoBoModal] = useState(false);
    const [bulkInvoiceModal, setBulkInvoiceModal] = useState(false);
    const [bulkInvoiceModalRC, setBulkInvoiceModalRC] = useState(false);
    const [bulkMainRegistrationModal, setBulkMainRegistrationModalModal] = useState(false);
    const [newVerify, setNewVerify] = useState(false);
    const data = modalData?.data || modalData;
    const [modal, setModal] = useState(false);
    const [pdfData, setPdfData] = useState(null);
    const [onHoledRemark, setOnHoldRemark] = useState("");
    const [onHoldModal, setOnHoldModal] = useState(false);
    const [verifyModal, setVerifyModal] = useState(false);
    const [verifyRemark, setVerifyRemark] = useState("");
    const [addSoModal, setAddSoModal] = useState(false);
    const [addSoModalData, setAddSoModalData] = useState(null);
    const [viewToVerifySoModal, setviewToVerifySoModal] = useState(false);
    const [viewToVerifySoModalData, setviewToVerifySoModalData] = useState(null);
    const [addInvoiceModal, setAddInvoiceModal] = useState(false);
    const [addInvoiceModalData, setAddInvoiceModalData] = useState(null);
    const [addInvoiceModalRC, setAddInvoiceModalRC] = useState(false);
    const [addInvoiceModalDataRC, setAddInvoiceModalDataRC] = useState(null);
    const [addInvoiceModalSM, setAddInvoiceModalSM] = useState(false);
    const [addInvoiceModalDataSM, setAddInvoiceModalDataSM] = useState(null);
    const [viewToVerifyInvoiceModal, setviewToVerifyInvoiceModal] = useState(false);
    const [viewToVerifyInvoiceModalData, setviewToVerifyInvoiceModalData] = useState(null);
    const [viewToVerifyInvoiceModalRC, setviewToVerifyInvoiceModalRC] = useState(false);
    const [viewToVerifyInvoiceModalDataRC, setviewToVerifyInvoiceModalDataRC] = useState(null);
    const [viewToVerifyInvoiceModalSM, setviewToVerifyInvoiceModalSM] = useState(false);
    const [viewToVerifyInvoiceModalDataSM, setviewToVerifyInvoiceModalDataSM] = useState(null);
    const [viewInvoiceModal, setViewInvoiceModal] = useState(false);
    const [viewInvoiceModalData, setViewInvoiceModalData] = useState(null);
    const [addSetOffModal, setAddSetOffModal] = useState(false);
    const [addSetOffModalData, setAddSetOffModalData] = useState(null);
    const [deleteRemark, setDeleteRemark] = useState("");
    const [deleteModal, setDeleteModal] = useState(false);
    const [dropdownMediums, setDropdownMediums] = useState([]);
    const [dropdownOlympiadDates, setDropdownOlympiadDates] = useState([]);
    const [medium, setMedium] = useState("");
    const [olympiadDate, setOlympiadDate] = useState("");
    const [transactionVerifyStatus, setTransactionVerifyStatus] = useState("");
    const [otpDeliveredStatus, setOtpDeliveredStatus] = useState("");
    const [viewValueModal, setViewValueModal] = useState(false);
    const [viewValue, setViewValue] = useState("");
    const [invoiceType, setInvoiceType] = useState(null); // "SM" | "RC"
    const [verifyInvoiceType, setVerifyInvoiceType] = useState(null); // "SM" | "RC"
    const [viewSoImageModal, setViewSoImageModal] = useState(false);
    const [viewSoImageModalData, setViewSoImageModalData] = useState(null);
    const [viewSMInvoiceImageModal, setViewSMInvoiceImageModal] = useState(false);
    const [viewSMInvoiceImageModalData, setViewSMInvoiceImageModalData] = useState(null);
    const [viewRCInvoiceImageModal, setViewRCInvoiceImageModal] = useState(false);
    const [viewRCInvoiceImageModalData, setViewRCInvoiceImageModalData] = useState(null);
    const navigate = useNavigate();

    const formatDate = (date) =>
        date ? new Date(date).toLocaleString() : "N/A";

    const uniqueCoordinators = [
        ...new Map(viewOlympiadModalData?.coordinators?.map((c) => [c.email, c])).values()
    ];
    const groupedSubjects = viewOlympiadModalData?.lineItems?.reduce((acc, item) => {
        const key = item.subjectName;

        if (!acc[key]) acc[key] = [];

        acc[key].push(item);

        return acc;
    }, {});

    const getClassNumber = (className) => {
        const match = className?.match(/\d+/);
        return match ? parseInt(match[0], 10) : 0;
    };

    useEffect(() => {
        if (hasSearched) {
            fetchAllData();
        }
    }, [newOrderStatus, paginationModel.page, paginationModel.pageSize]);

    useEffect(() => {
        getAllDropdowns();
        fetchSessions();
        fetchAccessModules();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    const fetchOlympiadAndTransactionOfLineItem = async (data) => {
        const result = await window.Platform.database.getRegistrationById({ regId: data.regId });
        if (result?.status) {
            setViewOlympiadModalData(result.data)
        }
        setOpenModal(true);
    };

    const fetchNewVerifyDetails = async (data) => {
        const result = await window.Platform.database.getRegistrationById({ regId: data.regId });
        if (result?.status) {
            setViewOlympiadModalData(result.data)
        }
        setNewVerify(true);
    };

    const handleUpdateStatus = async (row, status) => {
        try {
            setLoading(true);

            let data = {
                regId: row?.regId,
                status: row.RegistrationTypeId == 2 ? 3 : status,
                adminRemark: approveRemark || approveRemarkHold || rejectRemark || deleteRemark
            };
            let results = await window.Platform.database.updateOlympiadStatus(data);
            if (!results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            } else {
                window.NotificationUtils.showSuccess("Status updated successfully");
                fetchAllData();
            }

        } catch (error) {
            console.error("Update Status Error:", error);
            window.NotificationUtils.showError("Failed to update status");
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadExcel = async () => {
        try {
            setLoading(true);
            let data = {
                ownerId: rm,
                asm: userData?.role === 'asm' ? userData?.id : asm,
                rsm: userData?.role === 'rsm' ? userData?.id : rsm,
                search: search,
                olympiadDate: olympiadDate,
                medium: medium,
                is_verify: transactionVerifyStatus == "" ? "" : Number(transactionVerifyStatus),
                fromDate: startDate !== '' ? startDate : filteredDate?.startDate,
                toDate: endDate !== '' ? endDate : filteredDate?.endDate,
            };
            if (newOrderStatus !== 5) {
                data.approvalStatus = newOrderStatus;
            }
            let fileBlob = await window.Platform.database.downloadOlympiadExcel(data);

            const url = window.URL.createObjectURL(new Blob([fileBlob]));
            const link = document.createElement("a");
            link.href = url;
            
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;


            // link.setAttribute("download", "Olympiad_Report.xlsx");
            link.setAttribute("download", `${newOrderStatus == 0 ? 'Pending' : newOrderStatus == 1 ? 'Approved' : newOrderStatus == 2 ? "Verified" : newOrderStatus == 3 ? "Shipped" : newOrderStatus == 4 ? "Delivered" : newOrderStatus == 5 ? "All" : newOrderStatus == 6 ? "Rejected" : newOrderStatus == 7 ? "Deleted" : newOrderStatus == 8 ? "Partial Delivered" : newOrderStatus == 9 ? "On Hold" :  newOrderStatus == 10 ? "RM Remark" : newOrderStatus == 11 ? "Shipment Ready" : "Rejected"}_Olympiad_Report_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            // window.NotificationUtils.showSuccess("Download started");

        } catch (error) {
            console.error("Download Error:", error);
            window.NotificationUtils.showError("Failed to download file");
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadTransactionExcel = async () => {
        try {
            setLoading(true);
            let data = {
                is_match: transactionVerifyStatus || "",
                // ownerId: rm,
                // asm: userData?.role === 'asm' ? userData?.id : asm,
                // rsm: userData?.role === 'rsm' ? userData?.id : rsm,
                // search: search,
                // olympiadDate: olympiadDate,
                // medium: medium,
                // is_verify: transactionVerifyStatus == "" ? "" : Number(transactionVerifyStatus),
                fromDate: startDate !== '' ? startDate : filteredDate?.startDate,
                toDate: endDate !== '' ? endDate : filteredDate?.endDate,
            };
            let fileBlob = await window.Platform.database.downloadUploadedTransactionExcel(data);
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;

            const url = window.URL.createObjectURL(new Blob([fileBlob]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Olympiad_Transaction_Report_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            // window.NotificationUtils.showSuccess("Download started");

        } catch (error) {
            console.error("Download Error:", error);
            window.NotificationUtils.showError("Failed to download file");
        } finally {
            setLoading(false);
        }
    };

    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            if (response?.status) {
                const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
                setFilteredData(filterdData1[0])
            }
            else {
                window.NotificationUtils.showError("Something Went Wrong in session")
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
    };

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        if (results?.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
        }
        else {
            setAllUsers(results?.data)
            setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
            setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
            setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
            setLoading(false);
        }
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }

    }

    const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId: userData?.id,
                moduleId: "RsRohirsRs"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

    const formatDate1 = (dateStr) => {
        if (!dateStr) return "N/A";

        const date = new Date(dateStr);

        if (isNaN(date)) return "N/A";

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    function closeViewValueModal() {
        setViewValueModal(false);
        setViewValue("");
    }

    const formatDate2 = (dateStr) => {
        if (!dateStr) return "N/A";

        const date = new Date(dateStr);

        if (isNaN(date)) return "N/A";

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            // hour: "2-digit",
            // minute: "2-digit",
            // second: "2-digit",
            // hour12: true
        });
    };
    const handleOpenViewModal = (id) => {
        console.log(id, "isdsdsdsd")
        setModalData(id)
        setOpenViewModal(true);
    }

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
        setModalData([]);
    }

    const getAllAddOns = (seriesObj) => {
        let addOns = Array.isArray(seriesObj?.add_ons)
            ? [...seriesObj.add_ons]
            : [];

        Object.keys(seriesObj || {}).forEach(key => {
            if (
                !["series_id", "subjects", "add_ons"].includes(key) &&
                typeof seriesObj[key] === "number"
            ) {
                addOns.push(`${key} (${seriesObj[key]})`);
            }
        });

        return addOns;
    };

    const editData = async (data) => {
        const result = await window.Platform.database.getRegistrationById({ regId: data.regId });
        if (result?.status) {
            setEditModalData(result.data)
        }
        // setEditModalData(data)
        setEditMode(true)
        setAddModal(true)
    }

    const groupedBySeries = {};

    modalData?.content_assignment?.forEach(cls => {
        cls.series?.forEach(ser => {
            const seriesKey = ser.series_id || "N/A";

            if (!groupedBySeries[seriesKey]) {
                groupedBySeries[seriesKey] = [];
            }

            groupedBySeries[seriesKey].push({
                class_name: cls.class_name,
                subjects: ser.subjects || [],
                add_ons: getAllAddOns(ser) // ✅ FIXED
            });
        });
    });

    const downloadSingleOrder = async (data) => {
        setLoading(true);
        try {
            setLoading(true);
            let payload = {
                regId: data.regId
            };
            let fileBlob = await window.Platform.database.downloadOlympiadExcelById(payload);

            const url = window.URL.createObjectURL(new Blob([fileBlob]));
            const link = document.createElement("a");
            link.href = url;
            // link.setAttribute("download", "Olympiad_Report.xlsx");
            link.setAttribute("download", `Single_Olympiad_Report_${data.rno_id || ""}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.error("Download Error:", error);
            window.NotificationUtils.showError("Failed to download file");
        } finally {
            setLoading(false);
        }
    };

    async function handleUpdatePayment(row) {
        console.log(row, "asalkdbhasidbaskdbs")
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            setUpdatePaymentModal(true);

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            setEditModalDataNew(result.data);
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }
    async function handleAddSo(row) {
        console.log(row, "asalkdbhasidbaskdbs")
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            else {
                setAddSoModalData(result.data);
                setAddSoModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }
    async function handleviewToVerifySo(row) {
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            else {
                setviewToVerifySoModalData(result.data);
                setviewToVerifySoModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleSetOff(row) {
        console.log(row, "asalkdbhasidbaskdbs")
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            else {
                setAddSetOffModalData(result.data);
                setAddSetOffModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }


    async function handleSoImageView(row) {
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            else {
                setViewSoImageModalData(result.data);
                setViewSoImageModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleSMInvoiceImageView(row) {
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            else {
                setViewSMInvoiceImageModalData(result.data);
                setViewSMInvoiceImageModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleRCInvoiceImageView(row) {
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            else {
                setViewRCInvoiceImageModalData(result.data);
                setViewRCInvoiceImageModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }


    // async function handleAddInvoice(row) {
    //     console.log(row, "asalkdbhasidbaskdbs")
    //     try {
    //         setLoading(true);

    //         const result = await window.Platform.database.getRegistrationById({
    //             regId: row.regId
    //         });

    //         if (!result?.status) {
    //             window.NotificationUtils.showError("Failed to fetch data");
    //             return;
    //         }
    //         else {
    //             setAddInvoiceModalData(result.data);
    //             setAddInvoiceModal(true);
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         window.NotificationUtils.showError("Something went wrong");
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    async function handleAddInvoice(row, type) { // ← add type param
        try {
            setLoading(true);
            const result = await window.Platform.database.getRegistrationById({ regId: row.regId });
            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            } else {
                setAddInvoiceModalData(result.data);
                setInvoiceType(type); // ← store the type
                setAddInvoiceModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleAddInvoiceRC(row, type) { // ← add type param
        try {
            setLoading(true);
            const result = await window.Platform.database.getRegistrationById({ regId: row.regId });
            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            } else {
                setAddInvoiceModalDataRC(result.data);
                setInvoiceType(type); // ← store the type
                setAddInvoiceModalRC(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleAddInvoiceSM(row, type) { // ← add type param
        try {
            setLoading(true);
            const result = await window.Platform.database.getRegistrationById({ regId: row.regId });
            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            } else {
                setAddInvoiceModalDataSM(result.data);
                setInvoiceType(type); // ← store the type
                setAddInvoiceModalSM(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleViewInvoice(row) {
        console.log(row, "asalkdbhasidbaskdbs")
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
            else {
                setViewInvoiceModalData(result.data);
                setViewInvoiceModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    // async function handleViewToVerifyInvoice(row) {
    //     console.log(row, "asalkdbhasidbaskdbs")
    //     try {
    //         setLoading(true);

    //         const result = await window.Platform.database.getRegistrationById({
    //             regId: row.regId
    //         });

    //         if (!result?.status) {
    //             window.NotificationUtils.showError("Failed to fetch data");
    //             return;
    //         }
    //         else {
    //             setviewToVerifyInvoiceModalData(result.data);
    //             setviewToVerifyInvoiceModal(true);
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         window.NotificationUtils.showError("Something went wrong");
    //     } finally {
    //         setLoading(false);
    //     }
    // }
    async function handleViewToVerifyInvoice(row, type) { // ← add type param
        try {
            setLoading(true);
            const result = await window.Platform.database.getRegistrationById({ regId: row.regId });
            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            } else {
                setviewToVerifyInvoiceModalData(result.data);
                setVerifyInvoiceType(type); // ← store the type
                setviewToVerifyInvoiceModal(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleViewToVerifyInvoiceRC(row, type) { // ← add type param
        try {
            setLoading(true);
            const result = await window.Platform.database.getRegistrationById({ regId: row.regId });
            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            } else {
                setviewToVerifyInvoiceModalDataRC(result.data);
                setVerifyInvoiceType(type); // ← store the type
                setviewToVerifyInvoiceModalRC(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }
    async function handleViewToVerifyInvoiceSM(row, type) { // ← add type param
        try {
            setLoading(true);
            const result = await window.Platform.database.getRegistrationById({ regId: row.regId });
            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            } else {
                setviewToVerifyInvoiceModalDataSM(result.data);
                setVerifyInvoiceType(type); // ← store the type
                setviewToVerifyInvoiceModalSM(true);
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }


    const handleVerifyFunc = (rowData) => {
        setSelectedData(rowData);
        setVerifyModal(true);
        setVerifyRemark("");
    }

    async function handleVerifyRegistration(remark) {
        const isSuccess = window.confirm("Are you sure to verify this Registration");

        if (!isSuccess) return;

        try {
            setLoading(true);

            const result = await window.Platform.database.updateOlympiadStatus({
                regId: selectedData.regId,
                status: 2,
                adminRemark: remark
            });

            if (result?.status) {
                window.NotificationUtils.showSuccess(result?.message || "Updated Successfully");
                fetchAllData();
                setNewVerify(false);
                setVerifyModal(false);
                setVerifyRemark("");
                setSelectedData(null);
            }
            else {
                window.NotificationUtils.showError(result?.message || "Failed to fetch data");
                return;
            }

        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteFunc = (rowData) => {
        setSelectedData(rowData);
        setDeleteModal(true);
        setDeleteRemark("");
    }

    async function handleDeleteRemark(remark) {
        const isSuccess = window.confirm("Are you sure to delete this Registration");

        if (!isSuccess) return;

        try {
            setLoading(true);

            const result = await window.Platform.database.updateOlympiadStatus({
                regId: selectedData.regId,
                status: 7,
                adminRemark: remark
            });

            if (result?.status) {
                window.NotificationUtils.showSuccess(result?.message || "Updated Successfully");
                fetchAllData();
                setDeleteModal(false);
                setDeleteRemark("");
                setSelectedData(null);
            }
            else {
                window.NotificationUtils.showError(result?.message || "Failed to fetch data");
                return;
            }

        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    const handleOnholdFunc = (rowData) => {
        setSelectedData(rowData);
        setOnHoldModal(true);
        setOnHoldRemark("");
    }

    async function handleOnHoldRegistration(remark) {
        const isSuccess = window.confirm("Are you sure to put this Registration on hold");

        if (!isSuccess) return;

        try {
            setLoading(true);

            const result = await window.Platform.database.updateOlympiadStatus({
                regId: selectedData.regId,
                status: 9,
                adminRemark: remark
            });

            if (result?.status) {
                window.NotificationUtils.showSuccess(result?.message || "Updated Successfully");
                setOnHoldModal(false);
                setOnHoldRemark("");
                fetchAllData()
                setNewVerify(false);
                setSelectedData(null);
            }
            else {
                window.NotificationUtils.showError(result?.message || "Failed to fetch data");
                return;
            }

        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleTransactionDetails(row) {
        console.log(row, "asalkdbhasidbaskdbs")
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationById({
                regId: row.regId
            });

            setVerifyPaymentModal(true);

            if (!result?.status) {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }

            // ✅ store data
            setVerifyPaymentModalData(result.data);
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleShipment(row) {
        console.log(row, "asalkdbhasidbaskdbs")
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationByIdForWeb({
                regId: row.regId
            });

            if (result?.status) {
                setShipmentModalData(result.data);
                setShipmentModal(true);
            }
            else {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleShipmentForDeliver(row) {
        console.log(row, "asalkdbhasidbaskdbs")
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationByIdForWeb({
                regId: row.regId
            });

            if (result?.status) {
                setDeliverModalData(result.data);
                setDeliverModal(true);
            }
            else {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    async function handleShipmentForDeliverNew(row) {
        // const isSuccess = window.confirm("Are you sure to deliver");

        // if (!isSuccess) return;

        // try {
        //     setLoading(true);

        //     const payload = {
        //         regId: row.regId
        //     }

        //     const result = await window.Platform.database.updateRegStatusForDelivered(payload);

        //     if (result?.status) {
        //         window.NotificationUtils.showError(result?.message || "Delivered Successfully");
        //         fetchAllData();
        //     }
        //     else {
        //         window.NotificationUtils.showError("Failed to fetch data");
        //         return;
        //     }
        // } catch (err) {
        //     console.error(err);
        //     window.NotificationUtils.showError("Something went wrong");
        // } finally {
        //     setLoading(false);
        // }
        try {
            setLoading(true);

            const result = await window.Platform.database.getRegistrationByIdForWeb({
                regId: row.regId
            });

            if (result?.status) {
                setItemDeliverModalData(result.data);
                setItemDeliverModal(true);
            }
            else {
                window.NotificationUtils.showError("Failed to fetch data");
                return;
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    const handleDownloadSingleZipImage = async (data) => {
        try {
            console.log(data, "data for zip");

            const allAttachments = data?.transactions?.flatMap((transaction) => {
                try {
                    return JSON.parse(transaction?.attachmentPath || "[]");
                } catch (err) {
                    console.error("Invalid attachment JSON:", err);
                    return [];
                }
            }) || [];

            if (!allAttachments.length) {
                alert("No attachments found");
                return;
            }

            const zip = new JSZip();

            // Dynamic folder name
            const folderName =
                data?.rno_id?.replace(/\//g, "_") ||
                data?.so_id?.replace(/\//g, "_") ||
                "attachments";

            const folder = zip.folder(folderName);

            // Download all files dynamically
            for (const file of allAttachments) {
                if (!file?.fileName) continue;

                try {
                    const fileUrl = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
                    console.log(fileUrl, "fileUrlfileUrl")
                    const response = await fetch(fileUrl);

                    if (!response.ok) {
                        console.error(`Failed to fetch: ${file.fileName}`);
                        continue;
                    }

                    const buffer = await response.arrayBuffer();

                    folder.file(
                        file.originalName || file.fileName,
                        buffer
                    );
                } catch (err) {
                    console.error("Error downloading file:", file, err);
                }
            }

            // Generate ZIP
            const zipBlob = await zip.generateAsync({
                type: "blob",
                compression: "DEFLATE",
            });

            saveAs(zipBlob, `${folderName}.zip`);

        } catch (error) {
            console.error("ZIP download error:", error);
            alert("Failed to download attachments");
        }
    };

    const handleDownloadRmRemarkAttachmentZipImage = async (data) => {
        try {

            console.log(data, "data for zip");

            // PARSE rm_attachment
            let allAttachments = [];

            try {
                allAttachments = JSON.parse(data?.rm_attachment || "[]");
            } catch (err) {
                console.error("Invalid rm_attachment JSON:", err);
                allAttachments = [];
            }

            console.log(allAttachments, "allAttachments");

            if (!allAttachments.length) {
                alert("No attachments found");
                return;
            }

            const zip = new JSZip();

            // Dynamic folder name
            const folderName =
                data?.rno_id?.replace(/\//g, "_") ||
                data?.so_id?.replace(/\//g, "_") ||
                "attachments";

            const folder = zip.folder(folderName);

            // DOWNLOAD ALL FILES
            for (const file of allAttachments) {

                if (!file?.fileName) continue;

                try {

                    const fileUrl = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;

                    console.log(fileUrl, "fileUrl");

                    const response = await fetch(fileUrl);

                    if (!response.ok) {
                        console.error(`Failed to fetch: ${file.fileName}`);
                        continue;
                    }

                    const buffer = await response.arrayBuffer();

                    folder.file(
                        file.originalName || file.fileName,
                        buffer
                    );

                } catch (err) {

                    console.error(
                        "Error downloading file:",
                        file,
                        err
                    );
                }
            }

            // GENERATE ZIP
            const zipBlob = await zip.generateAsync({
                type: "blob",
                compression: "DEFLATE",
            });

            saveAs(zipBlob, `${folderName}_RM_Attachments.zip`);

        } catch (error) {

            console.error("ZIP download error:", error);

            alert("Failed to download attachments");
        }
    };


    const handleDownloadAllImagesZip = async (rows) => {
        setLoading(true);

        try {
            if (!rows?.length) {
                alert("No data available");
                return;
            }

            const zip = new JSZip();

            // Main ZIP folder
            const mainFolder = zip.folder("ALL_ATTACHMENTS");

            for (const row of rows) {

                // Dynamic attachment collection
                let allAttachments = [];

                // Case 1: Direct attachment field
                if (row?.attachment) {
                    try {
                        const parsed = JSON.parse(row.attachment || "[]");
                        allAttachments.push(...parsed);
                    } catch (err) {
                        console.error("Invalid attachment JSON:", err);
                    }
                }

                // Case 2: Transactions attachmentPath field
                if (row?.transactions?.length) {
                    const transactionAttachments = row.transactions.flatMap((transaction) => {
                        try {
                            return JSON.parse(transaction?.attachmentPath || "[]");
                        } catch (err) {
                            console.error("Invalid transaction attachment JSON:", err);
                            return [];
                        }
                    });

                    allAttachments.push(...transactionAttachments);
                }

                // Skip if no attachments
                if (!allAttachments.length) continue;

                // Dynamic folder name
                const folderName =
                    row?.rno_id?.replace(/\//g, "_") ||
                    row?.so_id?.replace(/\//g, "_") ||
                    row?.regId ||
                    "UNKNOWN";

                // Create separate folder for each record
                const rowFolder = mainFolder.folder(folderName);

                let index = 1;

                for (const file of allAttachments) {

                    if (!file?.fileName) continue;

                    try {
                        const fileUrl = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;

                        const response = await fetch(fileUrl);

                        if (!response.ok) {
                            console.error(`Failed to fetch ${file.fileName}`);
                            continue;
                        }

                        const buffer = await response.arrayBuffer();

                        // Extension handling
                        const ext =
                            file?.originalName?.split(".").pop() ||
                            file?.fileName?.split(".").pop() ||
                            "jpg";

                        // Dynamic ZIP filename
                        const zipFileName =
                            file.originalName ||
                            `${folderName}_${index}.${ext}`;

                        rowFolder.file(zipFileName, buffer);

                        index++;

                    } catch (err) {
                        console.error("File download error:", file, err);
                    }
                }
            }

            // Generate ZIP
            const zipBlob = await zip.generateAsync({
                type: "blob",
                compression: "DEFLATE",
            });

            saveAs(zipBlob, `ALL_ATTACHMENTS.zip`);

        } catch (error) {
            console.error("Bulk ZIP error:", error);
            alert("Failed to download ZIP");
        } finally {
            setLoading(false);
        }
    };

    function CustomToolbar() {

        const handleStatusChange = (statusValue) => {
            setHasSearched(true);
            setNewOrderStatus(statusValue);
        };

        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    flexWrap: "wrap"
                }}
            >
                {/* 🔹 STATUS FILTERS */}
                <div style={{ display: "flex", gap: "1px", flexWrap: "wrap" }}>

                    <Button
                        onClick={() => handleStatusChange(5)}
                        style={{
                            backgroundColor: newOrderStatus === 5 ? "#8787f470" : "white",
                            color: newOrderStatus === 5 ? "#000" : "black",
                        }}
                    >
                        All
                    </Button>

                    <Button
                        onClick={() => handleStatusChange(0)}
                        style={{
                            backgroundColor: newOrderStatus === 0 ? "#fe9f13" : "white",
                            color: newOrderStatus === 0 ? "white" : "black",
                        }}
                    >
                        Pending
                    </Button>
                    <Button
                        onClick={() => handleStatusChange(9)}
                        style={{
                            backgroundColor: newOrderStatus === 9 ? "#ff5722" : "white",
                            color: newOrderStatus === 9 ? "white" : "black",
                        }}
                    >
                        On-Hold
                    </Button>
                    <Button
                        onClick={() => handleStatusChange(10)}
                        style={{
                            backgroundColor: newOrderStatus === 10 ? "#003c6a" : "white",
                            color: newOrderStatus === 10 ? "white" : "black",
                        }}
                    >
                        RM Remark
                    </Button>
                    <Button
                        onClick={() => handleStatusChange(2)}
                        style={{
                            backgroundColor: newOrderStatus === 2 ? "#52d341" : "white",
                            color: newOrderStatus === 2 ? "white" : "black",
                        }}
                    >
                        Verified
                    </Button>
                    {/* <Button
                        onClick={() => handleStatusChange(10)}
                        style={{
                            backgroundColor: newOrderStatus === 10 ? "#52d341" : "white",
                            color: newOrderStatus === 10 ? "white" : "black",
                        }}
                    >
                        RM Remark
                    </Button> */}
                    <Button
                        onClick={() => handleStatusChange(1)}
                        style={{
                            backgroundColor: newOrderStatus === 1 ? "green" : "white",
                            color: newOrderStatus === 1 ? "white" : "black",
                        }}
                    >
                        Approved
                    </Button>
                    <Button
                        onClick={() => handleStatusChange(11)}
                        style={{
                            backgroundColor: newOrderStatus === 11 ? "#003c6a" : "#fff",
                            color: newOrderStatus === 11 ? "#fff" : "#000",
                        }}
                    >
                        Shipment Ready
                    </Button>
                    <Button
                        onClick={() => handleStatusChange(3)}
                        style={{
                            backgroundColor: newOrderStatus === 3 ? "#2196f3" : "white",
                            color: newOrderStatus === 3 ? "white" : "black",
                        }}
                    >
                        Shipped
                    </Button>

                    <Button
                        onClick={() => handleStatusChange(8)}
                        style={{
                            backgroundColor: newOrderStatus === 8 ? "#9c27b0" : "white",
                            color: newOrderStatus === 8 ? "white" : "black",
                        }}
                    >
                        Partial Delivered
                    </Button>

                    <Button
                        onClick={() => handleStatusChange(4)}
                        style={{
                            backgroundColor: newOrderStatus === 4 ? "#9c27b0" : "white",
                            color: newOrderStatus === 4 ? "white" : "black",
                        }}
                    >
                        Delivered
                    </Button>

                    <Button
                        onClick={() => handleStatusChange(6)}
                        style={{
                            backgroundColor: newOrderStatus === 6 ? "red" : "white",
                            color: newOrderStatus === 6 ? "white" : "black",
                        }}
                    >
                        Rejected
                    </Button>
                    {/* 
                    <Button
                        onClick={() => handleStatusChange(6)}
                        style={{
                            backgroundColor: newOrderStatus === 6 ? "#757575" : "white",
                            color: newOrderStatus === 6 ? "white" : "black",
                        }}
                    >
                        Saved For Later
                    </Button> */}

                    <Button
                        onClick={() => handleStatusChange(7)}
                        style={{
                            backgroundColor: newOrderStatus === 7 ? "#f52727" : "#ffffff",
                            color: newOrderStatus === 7 ? "white" : "#000000",
                        }}
                    >
                        Deleted
                    </Button>

                </div>

                {/* 🔹 PAGE SIZE */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "500" }}>
                        Select Page Size:
                    </Typography>

                    <Select
                        value={paginationModel.pageSize}
                        size="small"
                        onChange={(e) =>
                            setPaginationModel({
                                ...paginationModel,
                                pageSize: e.target.value
                            })
                        }
                        sx={{ width: 90, fontSize: 13 }}
                    >
                        {[10, 20, 30, 50, 100].map((size) => (
                            <MenuItem key={size} value={size}>
                                {size}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
            </GridToolbarContainer>
        );
    }

    const schoolColumns = () => {
        const stringOperators = getGridStringOperators().filter((op) =>
            ["contains"].includes(op.value)
        );

        let result = [
            {
                field: "regId",
                headerName: "Registration ID",
                sortable: false,
                width: 180,
                renderCell: (params) => {
                    const value = params.row.rno_id || "N/A";
                    return (
                        <Tooltip title={value}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "userName",
                sortable: false,
                headerName: "User Name",
                width: 200,
                renderCell: (params) => {
                    const value = params.row.userName || "N/A";
                    return (
                        <Tooltip title={value}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "schoolName",
                headerName: "School Name",
                sortable: false,
                width: 250,
                renderCell: (params) => {
                    const value = params.row.schoolName || "N/A";
                    return (
                        <Tooltip title={value}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "dates_of_olympiad",
                headerName: "Olympiad Date",
                sortable: false,
                width: 180,
                renderCell: (params) => {
                    const value = params.row.olympiad_date;
                    return (
                        <Tooltip title={value ? formatDate2(value) : "N/A" || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value ? formatDate2(value) : "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "createdAt",
                headerName: "Created At",
                sortable: false,
                width: 180,
                renderCell: (params) => {
                    const value = params.row.createdAt;
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value ? formatDate1(value) : "N/A"}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 10 && {
                field: "rmRemak1",
                headerName: "RM Remark",
                sortable: false,
                width: 250,
                renderCell: (params) => {
                    const value = params.row.rm_remark || "N/A";
                    return (
                        <div style={{ display: "flex" }}>
                            <RemoveRedEyeIcon className="mr-2" onClick={() => { setViewValue(value); setViewValueModal(true) }} />
                            {/* <Tooltip title={value || "N/A"}> */}
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value || "N/A"}
                            </Typography>
                            {/* </Tooltip> */}
                        </div>
                    );
                },
            },
            newOrderStatus == 10 && {
                field: "rmRemakAttachment1",
                headerName: "RM Remark Attachment",
                sortable: false,
                width: 250,
                renderCell: (params) => {
                    const value = params.row.rm_remark;
                    return (
                        <Tooltip>
                            <span>
                                <Button startIcon={<FileDownloadIcon />} variant="contained" size="small" onClick={() => handleDownloadRmRemarkAttachmentZipImage(params.row)} sx={{ minWidth: "70px" }} >
                                    Attachment
                                </Button>
                            </span>
                        </Tooltip>
                    );
                },
            },
            // {
            //     field: "status",
            //     headerName: "Status",
            //     sortable: false,
            //     width: 120,
            //     renderCell: (params) => {
            //         const status = params.row.status;
            //         const label =
            //             status === 0 ? "Pending" :
            //                 status === 1 ? "Approved" :
            //                     status === 2 ? "Rejected" : "N/A";

            //         return (
            //             <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
            //                 {label}
            //             </Typography>
            //         );
            //     },
            // },
            {
                field: "transactionStatus",
                headerName: "Payment Status",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    let name = params.row.transactionStatus.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ") || "N/A";
                    let setteled = params.row.is_sett_off || "";
                    const value = setteled == 1 ? "Settled" : params.row.transactionStatus || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {/* {setteled == 1 ? "Settled" : name} */}
                                { name }
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 9 && {
                field: "onHold",
                headerName: "Hold By",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.onHoldByName || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 9 && {
                field: "onHoldRemark",
                headerName: "Hold Remark",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.onHold_remark || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 2 && {
                field: "verify1",
                headerName: "Verify By",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.verifiedByName || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 2 && {
                field: "VerifyRemark1",
                headerName: "Verify Remark",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.verify_remark || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 1 && {
                field: "Approved1",
                headerName: "Approved By",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.approvedByName || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 1 && {
                field: "ApprovedRemark1",
                headerName: "Approval Remark",
                sortable: false,
                width: 300,
                renderCell: (params) => {
                    const value = params.row.approval_remark || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 3 && {
                field: "Shipped1",
                headerName: "Shipped By",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.shippedByName || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 4 && {
                field: "delivered1",
                headerName: "Delivered By",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.deliveredByName || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 6 && {
                field: "rejected1",
                headerName: "Rejected By",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.rejectedByName || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 6 && {
                field: "RejectedRemark1",
                headerName: "Rejected Remark",
                sortable: false,
                width: 300,
                renderCell: (params) => {
                    const value = params.row.rejected_remark || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 7 && {
                field: "deleted1",
                headerName: "Deleted By",
                sortable: false,
                width: 150,
                renderCell: (params) => {
                    const value = params.row.deletedByName || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            newOrderStatus == 7 && {
                field: "deletedRemark1",
                headerName: "Deleted Remark",
                sortable: false,
                width: 300,
                renderCell: (params) => {
                    const value = params.row.deleted_remark || "N/A";
                    return (
                        <Tooltip title={value || "N/A"}>
                            <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "Action",
                headerName: "Actions",
                sortable: false,
                width: 1250,
                renderCell: (params) => {
                    return (
                        <Stack direction={"row"} spacing={1}>
                            {(userData?.role == "finance head" || userData?.role == "super admin") && newOrderStatus == 2 &&
                                <Tooltip>
                                    <Button variant="contained" color="info"
                                        disabled={params.row.transactionStatus == "completed" || params?.row?.set_off_amount}
                                        onClick={() => { handleSetOff(params?.row) }}

                                    >
                                        Set Off
                                    </Button>
                                </Tooltip>}
                            {/* {newOrderStatus == 1 && (userData?.role.includes("admin") || userData?.role.includes("finance")) && <Tooltip>
                                {params?.row?.RegistrationTypeId != 2 ?
                                    <>
                                        {params?.row?.so_action == "added" ?
                                            <>
                                                {(userData?.role == "super admin" || ((accessModulesData && accessModulesData[0]?.verifySo?.toLowerCase() != "no") && userData?.role.includes("admin"))) ?
                                                    <Button variant="contained" color="warning" style={{ width: "130px" }}
                                                        onClick={() => { handleviewToVerifySo(params?.row) }}
                                                    >
                                                        Verify SO
                                                    </Button>
                                                    :
                                                    <Button variant="contained" color="warning" style={{ width: "130px" }} disabled>
                                                        For Verify Team
                                                    </Button>
                                                }
                                            </>
                                            :
                                            <>
                                                {params?.row?.so_action == "verified" ?
                                                    <Button variant="contained" color="info" style={{ width: "130px" }}>
                                                        Verified
                                                    </Button>
                                                    :
                                                    <>
                                                        {(userData?.role == "super admin" || userData?.role.includes("finance")) && params?.row?.so_action == "disputed" ?
                                                            <Button variant="contained" color="error" style={{ width: "130px" }}
                                                                onClick={() => { handleAddSo(params?.row) }}
                                                            >
                                                                Disputed
                                                            </Button>
                                                            :
                                                            <>
                                                                {(userData?.role == "super admin" || userData?.role.includes("finance")) ?
                                                                    <Button variant="contained" color="success" style={{ width: "130px" }}
                                                                        onClick={() => { handleAddSo(params?.row) }}
                                                                    >
                                                                        Add SO
                                                                    </Button>
                                                                    :
                                                                    <Button variant="contained" color="error" style={{ width: "130px" }} disabled>
                                                                        for finance
                                                                    </Button>
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                    :
                                    <Button disabled style={{ width: "130px", color: "#ffffff", backgroundColor: "#9b0000" }}> Not Applicable</Button>
                                }
                            </Tooltip>} */}
                            {newOrderStatus == 1 && (userData?.role.includes("admin") || userData?.role.includes("finance")) &&
                                <Tooltip>
                                    {params?.row?.RegistrationTypeId != 2 ?
                                        <>
                                            {params?.row?.so_action == "added" ?
                                                <>
                                                    {/* VERIFY SO — super admin OR admin with verifySo == "yes" */}
                                                    {(userData?.role == "super admin" ||
                                                        userData?.role.includes("finance") === false && userData?.role.includes("admin") && accessModulesData?.[0]?.verifySo?.toLowerCase() == "yes") ?
                                                        <Button variant="contained" color="warning" style={{ width: "130px" }}
                                                            onClick={() => { handleviewToVerifySo(params?.row) }}
                                                        >
                                                            Verify SO
                                                        </Button>
                                                        :
                                                        <span style={{ width: "130px" }}>

                                                        </span>
                                                    }
                                                </>
                                                :
                                                <>
                                                    {params?.row?.so_action == "verified" ?
                                                        <Button variant="contained" color="info" style={{ width: "130px" }}>
                                                            Verified
                                                        </Button>
                                                        :
                                                        <>
                                                            {params?.row?.so_action == "disputed" ?
                                                                <>
                                                                    {/* DISPUTE SO — super admin OR finance OR admin with disputeSo == "yes" */}
                                                                    {(userData?.role == "super admin" ||
                                                                        userData?.role.includes("finance") ||
                                                                        (userData?.role.includes("admin") && accessModulesData?.[0]?.disputeSo?.toLowerCase() == "yes")) ?
                                                                        <Button variant="contained" color="error" style={{ width: "130px" }}
                                                                            onClick={() => { handleAddSo(params?.row) }}
                                                                        >
                                                                            Disputed
                                                                        </Button>
                                                                        :
                                                                        <span style={{ width: "130px" }}>

                                                                        </span>
                                                                    }
                                                                </>
                                                                :
                                                                <>
                                                                    {/* ADD SO — super admin OR finance OR admin with addSo == "yes" */}
                                                                    {(userData?.role == "super admin" ||
                                                                        userData?.role.includes("finance") ||
                                                                        (userData?.role.includes("admin") && accessModulesData?.[0]?.addSo?.toLowerCase() == "yes")) ?
                                                                        <Button variant="contained" color="success" style={{ width: "130px" }}
                                                                            onClick={() => { handleAddSo(params?.row) }}
                                                                        >
                                                                            Add SO
                                                                        </Button>
                                                                        :
                                                                        <span style={{ width: "130px" }}>

                                                                        </span>
                                                                    }
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                        </>
                                        :
                                        <Button disabled style={{ width: "130px", color: "#ffffff", backgroundColor: "#9b0000" }}>
                                            Not Applicable
                                        </Button>
                                    }
                                </Tooltip>
                            }
                            {newOrderStatus != 7 && newOrderStatus != 6 && userData?.role == "super admin" && params?.row?.is_sett_off == 1 ?
                                <span style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "150px" }}>Payment Settled</span>
                                :
                                <>
                                    {newOrderStatus != 7 && newOrderStatus != 6 && userData?.role == "super admin" && <Tooltip>
                                        {params?.row?.transactionStatus == "completed" ? <span
                                            style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "150px" }}
                                        >
                                            Payment Completed
                                        </span>
                                            :
                                            <Button
                                                disabled={params?.row?.is_sett_off == 1}
                                                variant="contained"
                                                color="primary"
                                                onClick={() => { setUpdatePaymentModal(true); handleUpdatePayment(params?.row) }}
                                                style={{ width: "150px" }}
                                            >
                                                Update Payment
                                            </Button>
                                        }
                                    </Tooltip>}
                                </>
                            }
                            <Tooltip title="View Details">
                                <IconButton variant="extended" color="primary"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        fetchOlympiadAndTransactionOfLineItem(params.row);
                                    }}
                                >
                                    <RemoveRedEyeIcon />
                                </IconButton>
                            </Tooltip>
                            {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <Tooltip title="Download Single Registration">
                                <IconButton variant="extended" color="primary" onClick={(e) => {
                                    e.stopPropagation();
                                    downloadSingleOrder(params.row);
                                }} >
                                    <FileDownloadIcon />
                                </IconButton>
                            </Tooltip>}

                            {/* {newOrderStatus != 7 && newOrderStatus != 6 && newOrderStatus != 4 && userData?.role.includes('admin') && (accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no") && <Tooltip title="Edit"> */}
                            {(((newOrderStatus == 0 || newOrderStatus == 9 || newOrderStatus == 10 || newOrderStatus == 1 || newOrderStatus == 2) && userData?.role.includes('admin')) || (userData?.role.includes('super admin') && (newOrderStatus != 6 && newOrderStatus != 7))) && (accessModulesData && accessModulesData[0]?.is_update?.toLowerCase() != "no") && <Tooltip title="Edit">
                                <IconButton variant="extended"
                                    onClick={(e) => {
                                        editData(params.row);
                                    }} >
                                    <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                                </IconButton  >
                            </Tooltip>}

                            {/* {userData?.role == "super admin" || userData?.role.includes("finance") && (accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no") && newOrderStatus == 2 && */}
                            {newOrderStatus != 7 && newOrderStatus != 6 && ((userData?.role == "super admin" || userData?.role.includes("finance")) || (userData?.role.includes("admin") && accessModulesData?.[0]?.is_approve?.toLowerCase() !== "no")) && newOrderStatus == 2 && (
                                <Tooltip title="Approve">
                                    <IconButton
                                        sx={{ color: "green" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedRow(params.row);
                                            setOpenModalWhenVerify(true);

                                            // if (window.confirm("Are you sure you want to approve this?")) {
                                            //     handleUpdateStatus(params.row, 1);
                                            // }
                                        }}
                                    >
                                        <ThumbUpIcon />
                                    </IconButton>
                                </Tooltip>)}

                            {/* {newOrderStatus != 6 && userData?.role == "super admin" && (accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no") && newOrderStatus != 7 && newOrderStatus != 1 && <Tooltip title="Reject"> */}
                            {/* {(newOrderStatus == 0 || newOrderStatus == 2 || newOrderStatus == 9 || newOrderStatus == 10) && (userData?.role == "super admin" || (userData?.role.includes("admin") && accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no")) && <Tooltip title="Reject">
                                <IconButton
                                    // disabled={params.row?.status === 2}
                                    // disabled={params.row?.status === 6 || params.row?.status === 2}
                                    sx={{ color: "red" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedRow(params.row);
                                        setRejectModal(true);
                                    }}
                                >
                                    <ThumbDownIcon />
                                </IconButton>
                            </Tooltip>} */}

                            {newOrderStatus != 7 && newOrderStatus != 6 && (userData?.master == 1 && userData?.super == 1 && userData?.role == "super admin") && <Tooltip title="Delete">
                                <IconButton
                                    sx={{ color: "red" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteFunc(params.row)
                                        // if (window.confirm("Are you sure you want to delete this?")) {
                                        //     handleUpdateStatus(params.row, 7);
                                        // }
                                    }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>}
                            {newOrderStatus != 7 && newOrderStatus != 6 && (userData?.role.includes('admin')) &&
                                <Tooltip>
                                    {(newOrderStatus == 0 || newOrderStatus == 9 || newOrderStatus == 10) ? <Button variant="contained" color="warning"
                                        onClick={() => {
                                            fetchNewVerifyDetails(params?.row);
                                        }}
                                        style={{ width: "100px" }}
                                    >
                                        Verify
                                    </Button>
                                        :
                                        <>
                                            {(userData?.role.includes('finance')) && <Button variant="contained" color="success"
                                                onClick={() => {
                                                    setVerifyPaymentModal(true);
                                                    handleTransactionDetails(params?.row)
                                                }}
                                                style={{ width: "200px" }}
                                            >
                                                Transaction Details
                                            </Button>}
                                        </>}
                                </Tooltip>}
                            {newOrderStatus != 7 && newOrderStatus != 6 && (userData?.role.includes('finance') || (userData?.role == "super admin") && newOrderStatus == 2) &&
                                <Tooltip>
                                    <Button variant="contained" color="success"
                                        onClick={() => {
                                            setVerifyPaymentModal(true);
                                            handleTransactionDetails(params?.row)
                                        }}
                                        style={{ width: "200px" }}
                                    >
                                        Transaction Details
                                    </Button>
                                </Tooltip>}
                            {/* {(userData?.role == "scm" || userData?.role == "super admin") && newOrderStatus == 11 &&
                                // params?.row?.sobo_added == "yes" &&
                                params?.row?.so_action == "verified" &&
                                <Tooltip>
                                    <Button style={{ color: "#dcd6d6", backgroundColor: "#0a7b00", width: "170" }}
                                        onClick={() => {
                                            setShipmentModal(true);
                                            handleShipment(params?.row)
                                        }}
                                    >
                                        Item Shipment
                                    </Button>
                                </Tooltip>} */}
                            {(userData?.role == "scm" || userData?.role == "super admin" || (userData?.role.includes("admin") &&
                                accessModulesData?.[0]?.itemShipment?.toLowerCase() == "yes")) && newOrderStatus == 11 &&
                                params?.row?.so_action == "verified" &&
                                <Tooltip>
                                    <Button style={{ color: "#dcd6d6", backgroundColor: "#0a7b00", width: "170" }}
                                        onClick={() => {
                                            setShipmentModal(true);
                                            handleShipment(params?.row)
                                        }}
                                    >
                                        Item Shipment
                                    </Button>
                                </Tooltip>}
                            {/* {(userData?.role.includes('finance') || userData?.role.includes("admin")) && newOrderStatus == 3 &&
                                <Tooltip>
                                    {params?.row?.invoice_action == "added" ?
                                        <>
                                            {(userData?.role == "super admin" || ((accessModulesData && accessModulesData[0]?.verifyInv?.toLowerCase() != "no") && userData?.role.includes("admin"))) ?
                                                <Button variant="contained" color="warning" style={{ width: "140px" }}
                                                    onClick={() => { handleViewToVerifyInvoice(params?.row) }}
                                                >
                                                    Verify Invoice
                                                </Button>
                                                :
                                                <Button variant="contained" color="warning" style={{ width: "140px" }} disabled>
                                                    For Verify Team
                                                </Button>
                                            }
                                        </>
                                        :
                                        <>
                                            {params?.row?.invoice_action == "verified" ?
                                                <Button variant="contained" color="info" style={{ width: "140px" }}>
                                                    Verified
                                                </Button>
                                                :
                                                <>
                                                    {(userData?.role == "super admin" || userData?.role.includes("finance")) && params?.row?.invoice_action == "disputed" ?
                                                        <Button variant="contained" color="error" style={{ width: "140px" }}
                                                            onClick={() => { handleAddInvoice(params?.row) }}
                                                        >
                                                            <RemoveRedEyeIcon style={{ marginRight: "2px", height: "15px" }} />
                                                            Disputed
                                                        </Button>
                                                        :
                                                        <>
                                                            {(userData?.role == "super admin" || userData?.role.includes("finance")) ?
                                                                <Button variant="contained" color="success" style={{ width: "140px" }}
                                                                    onClick={() => { handleAddInvoice(params?.row) }}
                                                                >
                                                                    Add Invoice
                                                                </Button>
                                                                :
                                                                <Button variant="contained" color="error" style={{ width: "140px" }} disabled>
                                                                    for finance
                                                                </Button>
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                </Tooltip>} */}
                            <span style={{ display: "inline-flex", width: "140px", flexShrink: 0 }}>
                                {(userData?.role.includes('finance') || userData?.role.includes("admin")) && newOrderStatus == 3 &&
                                    <Tooltip>
                                        {params?.row?.smInvoiceAction == "added" ?
                                            <>
                                                {/* VERIFY INVOICE — super admin OR admin with verifySMInv == "yes" */}
                                                {(userData?.role == "super admin" ||
                                                    (userData?.role.includes("admin") && accessModulesData?.[0]?.verifySmInv?.toLowerCase() == "yes")) ?
                                                    <span>
                                                        {(params?.row?.RegistrationTypeId == 3 || params?.row?.RegistrationTypeId == 1) && <Button variant="contained" color="warning" style={{ width: "140px" }}
                                                            // onClick={() => { handleViewToVerifyInvoice(params?.row) }}
                                                            onClick={() => { handleViewToVerifyInvoiceSM(params?.row, "SM") }} // ← "SM"
                                                        >
                                                            Verify SM Inv
                                                        </Button>}
                                                    </span>
                                                    :
                                                    <span style={{ width: "140px" }}>

                                                    </span>
                                                }
                                            </>
                                            :
                                            <>
                                                {params?.row?.smInvoiceAction == "verified" ?
                                                    <span>
                                                        {<Button variant="contained" color="info" style={{ width: "140px" }}>
                                                            Verified
                                                        </Button>}
                                                    </span>
                                                    :
                                                    <>
                                                        {params?.row?.smInvoiceAction == "disputed" ?
                                                            <>
                                                                {/* DISPUTE INVOICE — super admin OR finance OR admin with disputeSmInv == "yes" */}
                                                                {(userData?.role == "super admin" ||
                                                                    userData?.role.includes("finance") ||
                                                                    (userData?.role.includes("admin") && accessModulesData?.[0]?.disputeSmInv?.toLowerCase() == "yes")) ?
                                                                    <span>
                                                                        {(params?.row?.RegistrationTypeId == 3 || params?.row?.RegistrationTypeId == 1) && <Button variant="contained" color="error" style={{ width: "140px" }}
                                                                            // onClick={() => { handleAddInvoice(params?.row) }}
                                                                            onClick={() => { handleAddInvoiceSM(params?.row, "SM") }} // ← "SM"
                                                                        >
                                                                            {/* <RemoveRedEyeIcon style={{ marginRight: "2px", height: "15px" }} /> */}
                                                                            Disputed SM Inv
                                                                        </Button>}
                                                                    </span>
                                                                    :
                                                                    <span style={{ width: "140px" }}>

                                                                    </span>
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                {/* ADD INVOICE — super admin OR finance OR admin with addSmInv == "yes" */}
                                                                {(userData?.role == "super admin" ||
                                                                    userData?.role.includes("finance") ||
                                                                    (userData?.role.includes("admin") && accessModulesData?.[0]?.addSmInv?.toLowerCase() == "yes")) ?
                                                                    <span>
                                                                        {(params?.row?.RegistrationTypeId == 3 || params?.row?.RegistrationTypeId == 1) ? <Button variant="contained" color="success" style={{ width: "140px" }}
                                                                            // onClick={() => { handleAddInvoice(params?.row) }}
                                                                            onClick={() => { handleAddInvoiceSM(params?.row, "SM") }} // ← "SM"
                                                                        >
                                                                            Add SM Inv
                                                                        </Button>
                                                                            :
                                                                            <Button variant="contained" color="success" style={{ width: "140px" }} disabled>
                                                                                SM Inv Not Req
                                                                            </Button>
                                                                        }
                                                                    </span>
                                                                    :
                                                                    <span style={{ width: "140px" }}>

                                                                    </span>
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }
                                    </Tooltip>
                                }
                            </span>
                            <span style={{ display: "inline-flex", width: "140px", flexShrink: 0 }}>
                                {(userData?.role.includes('finance') || userData?.role.includes("admin")) && newOrderStatus == 3 &&
                                    <Tooltip>
                                        {params?.row?.rcInvoiceAction == "added" ?
                                            <>
                                                {/* VERIFY INVOICE — super admin OR admin with verifyRcInv == "yes" */}
                                                {(userData?.role == "super admin" ||
                                                    (userData?.role.includes("admin") && accessModulesData?.[0]?.verifyRcInv?.toLowerCase() == "yes")) ?
                                                    <span>
                                                        {(params?.row?.RegistrationTypeId == 2 || params?.row?.RegistrationTypeId == 1) && <Button variant="contained" color="warning" style={{ width: "140px" }}
                                                            // onClick={() => { handleViewToVerifyInvoice(params?.row) }}
                                                            onClick={() => { handleViewToVerifyInvoiceRC(params?.row, "RC") }} // ← "RC"
                                                        >
                                                            Verify RC Inv
                                                        </Button>}
                                                    </span>
                                                    :
                                                    <span style={{ width: "140px" }}>

                                                    </span>
                                                }
                                            </>
                                            :
                                            <>
                                                {params?.row?.rcInvoiceAction == "verified" ?
                                                    <span>
                                                        {<Button variant="contained" color="info" style={{ width: "140px" }}>
                                                            Verified
                                                        </Button>}
                                                    </span>
                                                    :
                                                    <>
                                                        {params?.row?.rcInvoiceAction == "disputed" ?
                                                            <>
                                                                {/* DISPUTE INVOICE — super admin OR finance OR admin with disputeInv == "yes" */}
                                                                {(userData?.role == "super admin" ||
                                                                    userData?.role.includes("finance") ||
                                                                    (userData?.role.includes("admin") && accessModulesData?.[0]?.disputeRcInv?.toLowerCase() == "yes")) ?
                                                                    <span>
                                                                        {(params?.row?.RegistrationTypeId == 2 || params?.row?.RegistrationTypeId == 1) && <Button variant="contained" color="error" style={{ width: "140px", marginLeft: "5px" }}
                                                                            // onClick={() => { handleAddInvoice(params?.row) }}
                                                                            onClick={() => { handleAddInvoiceRC(params?.row, "RC") }} // ← "RC"
                                                                        >
                                                                            {/* <RemoveRedEyeIcon style={{ marginRight: "2px", height: "15px" }} /> */}
                                                                            Disputed RC inv
                                                                        </Button>}
                                                                    </span>
                                                                    :
                                                                    <span style={{ width: "140px" }}>

                                                                    </span>
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                {/* ADD INVOICE — super admin OR finance OR admin with addRcInv == "yes" */}
                                                                {(userData?.role == "super admin" ||
                                                                    userData?.role.includes("finance") ||
                                                                    (userData?.role.includes("admin") && accessModulesData?.[0]?.addRcInv?.toLowerCase() == "yes")) ?
                                                                    <span>
                                                                        {(params?.row?.RegistrationTypeId == 2 || params?.row?.RegistrationTypeId == 1) ? <Button variant="contained" color="success" style={{ width: "140px" }}
                                                                            // onClick={() => { handleAddInvoice(params?.row) }}
                                                                            onClick={() => { handleAddInvoiceRC(params?.row, "RC") }} // ← "RC"
                                                                        >
                                                                            Add RC Inv
                                                                        </Button>
                                                                            :
                                                                            <Button variant="contained" color="success" style={{ width: "140px" }} disabled>
                                                                                RC Inv Not Req
                                                                            </Button>
                                                                        }
                                                                    </span>
                                                                    :
                                                                    <span style={{ width: "140px" }}>

                                                                    </span>
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }
                                    </Tooltip>
                                }
                            </span>
                            {/* {(userData?.role == "scm" || userData?.role == "super admin") && (newOrderStatus == 3 || newOrderStatus == 8) &&
                                <Tooltip>
                                    <Button style={{ color: "#dcd6d6", backgroundColor: "#d26f05", width: "170" }}
                                        onClick={() => {
                                            setDeliverModal(true);
                                            handleShipmentForDeliver(params?.row)
                                        }}
                                    >
                                        Update Shipment
                                    </Button>
                                </Tooltip>} */}
                            {(userData?.role == "scm" || userData?.role == "super admin" ||
                                (userData?.role.includes("admin") && accessModulesData?.[0]?.updateShipment?.toLowerCase() == "yes")) &&
                                (newOrderStatus == 3 || newOrderStatus == 8) &&
                                <Tooltip>
                                    <Button style={{ color: "#dcd6d6", backgroundColor: "#d26f05", width: "170" }}
                                        onClick={() => {
                                            setDeliverModal(true);
                                            handleShipmentForDeliver(params?.row)
                                        }}
                                    >
                                        Update Shipment
                                    </Button>
                                </Tooltip>}

                            {/* {newOrderStatus != 7 && newOrderStatus != 6 && (userData?.role.includes('admin')) && newOrderStatus == 3 &&
                                <Tooltip>
                                    <Button style={{ color: "#dcd6d6", backgroundColor: "#376e1d", width: "170" }}
                                        onClick={() => {
                                            setItemDeliverModal(true);
                                            handleShipmentForDeliverNew(params?.row)
                                        }}
                                    >
                                        Item Deliver
                                    </Button>
                                </Tooltip>} */}
                            {newOrderStatus != 7 && newOrderStatus != 6 && newOrderStatus == 3 &&
                                (userData?.role == "super admin" || userData?.role == "scm" ||
                                    (userData?.role.includes("admin") && accessModulesData?.[0]?.itemDeliver?.toLowerCase() == "yes")) &&
                                <Tooltip>
                                    <Button style={{ color: "#dcd6d6", backgroundColor: "#376e1d", width: "170" }}
                                        onClick={() => {
                                            setItemDeliverModal(true);
                                            handleShipmentForDeliverNew(params?.row)
                                        }}
                                    >
                                        Item Deliver
                                    </Button>
                                </Tooltip>}
                            {(newOrderStatus == 1 || newOrderStatus == 11 || newOrderStatus == 3 || newOrderStatus == 8 || newOrderStatus == 4) &&
                                <Tooltip>
                                    {(params?.row?.so_action == null || params?.row?.so_action == "" || params?.row?.so_action == undefined) ?
                                        <Button variant="contained" color="success" style={{ width: "100px" }} disabled>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#EFEFEF"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                            SO
                                        </Button>
                                        :
                                        <Button variant="contained" style={{ width: "100px", backgroundColor: "#0072af", color: "#dcd6d6", fontWeight: "500", fontSize: "13px" }}
                                            onClick={() => { handleSoImageView(params?.row) }}
                                        >
                                            {/* <span >📎</span>  */}
                                            <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#EFEFEF"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                            <span className="ml-1">SO</span>
                                        </Button>
                                    }
                                </Tooltip>}
                            <Tooltip>
                                {(newOrderStatus == 3 || newOrderStatus == 8 || newOrderStatus == 4) &&
                                    <>
                                        {(params?.row?.smInvoiceAction == null || params?.row?.smInvoiceAction == "" || params?.row?.smInvoiceAction == undefined) ?
                                            <Button variant="contained" color="success" style={{ width: "100px" }} disabled
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#EFEFEF"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                                SM INV
                                            </Button>
                                            :
                                            <Button variant="contained" style={{ width: "100px", backgroundColor: "#0072af", color: "#dcd6d6", fontWeight: "500", fontSize: "13px" }}
                                                onClick={() => { handleSMInvoiceImageView(params?.row) }}

                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#EFEFEF"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                                <span className="ml-1">SM INV</span>
                                            </Button>}
                                    </>
                                }

                                {(newOrderStatus == 3 || newOrderStatus == 8 || newOrderStatus == 4) &&
                                    <>      {(params?.row?.rcInvoiceAction == null || params?.row?.rcInvoiceAction == "" || params?.row?.rcInvoiceAction == undefined) ?
                                        <Button variant="contained" color="success" style={{ width: "100px" }} disabled
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#EFEFEF"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                            RC INV
                                        </Button>
                                        : <Button variant="contained" style={{ width: "100px", backgroundColor: "#0072af", color: "#dcd6d6", fontWeight: "500", fontSize: "13px" }}
                                            onClick={() => { handleRCInvoiceImageView(params?.row) }}

                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#EFEFEF"><path d="M280-280h400v-80H280v80Zm200-120 160-160-56-56-64 62v-166h-80v166l-64-62-56 56 160 160Zm0 320q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                                            <span className="ml-1">RC INV</span>
                                        </Button>}
                                    </>
                                }
                            </Tooltip>
                        </Stack>
                    );
                },

            },
            {
                field: "DownloadAttachment",
                headerName: "Download Attachment",
                width: 200,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <>
                            <Tooltip>
                                <span>
                                    <Button startIcon={<FileDownloadIcon />} variant="contained" size="small" onClick={() => handleDownloadSingleZipImage(params.row)} sx={{ minWidth: "70px" }} >
                                        Attachment
                                    </Button>
                                </span>
                            </Tooltip>
                        </>
                    );
                },
            },
        ].filter(Boolean);

        return result;
    };

    const exportAutomationLogsExcel = async () => {
        setLoading(true);
        try {
            let data = {
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                search: search,
                olympiadDate: olympiadDate,
                medium: medium,
                is_verify: transactionVerifyStatus == "" ? "" : Number(transactionVerifyStatus),
                ownerId: rm,
                startDate: startDate != '' ? startDate : filteredDate?.startDate,
                endDate: endDate != '' ? endDate : filteredDate?.endDate,
                is_success: automationStatus
            }
            let result = await window.Platform.database.exportData("order/downloadAutomationLogsExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `AutomationLogs_Report_${formattedDate}.xlsx`);
            // link.setAttribute("download", "attendance.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    // const fetchEmployees = async () => {
    //     setLoading(true);
    //     try {
    //         setVisibleEmployees([]);

    //         let results = await window.Platform.database.getAutomationLogs({
    //             rsm: userData?.role == 'rsm' ? userData?.id : rsm,
    //             asm: userData?.role == 'asm' ? userData?.id : asm,
    //             ownerId: rm,
    //             pageNumber: paginationModel.page,
    //             recordPerPage: paginationModel.pageSize,
    //             startDate: startDate != '' ? startDate : filteredDate?.startDate,
    //             endDate: endDate != '' ? endDate : filteredDate?.endDate,
    //             is_success: automationStatus
    //         });
    //         setRowCount(results?.total)

    //         const jsonArrayWithId = results?.data?.map((obj, index) => ({
    //             ...obj,
    //             id: index + 1,
    //         }));
    //         setVisibleEmployees(jsonArrayWithId);
    //         if (results.success) {
    //             setLoading(false);
    //         } else {
    //             setLoading(false);
    //             window.NotificationUtils.showError(results.message);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         setLoading(false);
    //     }
    // };

    const clearFilter = async () => {
        setOlympiadDate("");
        setMedium("");
        setSearch("");
        setTransactionVerifyStatus("");
        setHasSearched(false);
        setNewOrderStatus(0);
        setLoading(true);
        setRsm("");
        setAsm("");
        setRm("");
        setStartDate("")
        setEndDate("")
        setAutomationStatus("")
        setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
        setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
        setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
        setVisibleEmployees([]);
        setAccessChanges([]);
        setNewRows([]);
        setRowCount(0);
        setLoading(false);
    };

    const onClose = async () => {
        try {
            setAddModal(false)
            setEditMode(false)
            setEditModalData(false)
        }
        catch (error) {
            setLoading(false)
        }
    }

    const fetchAllData = async () => {
        setLoading(true);
        try {
            let data = {
                ownerId: rm,
                asm: userData?.role === 'asm' ? userData?.id : asm,
                rsm: userData?.role === 'rsm' ? userData?.id : rsm,
                search: search,
                olympiadDate: olympiadDate,
                medium: medium,
                is_verify: transactionVerifyStatus == "" ? "" : Number(transactionVerifyStatus),
                fromDate: startDate !== '' ? startDate : filteredDate?.startDate,
                toDate: endDate !== '' ? endDate : filteredDate?.endDate,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
            };

            // ✅ ADD CONDITIONALLY
            if (newOrderStatus !== 5) {
                data.approvalStatus = newOrderStatus;
            }

            console.log("Payload >>>", data); // 🔥 MUST CHECK

            let results = await window.Platform.database.fetchOlympiad(data);

            console.log(results?.status, "AAAAAAAAAAAAAAAAAAA(((((((((((((((((((((((99999999999999")
            if (results?.status) {
                setLoading(false);
                window.NotificationUtils.showError("Something went wrong");
            }
            else {
                setNewRows(results?.data)
                let jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
                setRowCount(results?.data1)
                setAccessChanges(jsonArrayWithId);
                setLoading(false)
            }

        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Error Fetching Data");
        } finally {
            setLoading(false);
        }
    };

    const isRowGreen = (row) => {
        const isCompleted = row?.transactionStatus === "completed";
        const allVerified = Array.isArray(row?.transactions) && row.transactions.length > 0 ? row.transactions.every((ele) => ele.is_verify == 1) : false;
        const isSetOff = row.is_sett_off == 1 ? false : true;

        return isCompleted && allVerified && isSetOff;
    };

    const getRowClassName = (params) => {
        if (isRowGreen(params.row)) {
            return "green-row";
        }
        return "";
    };

    const renderTabContent = () => {
        return (<>
            <DataGridContainer
                style={{ height: !accessChanges.length ? "200px" : "auto" }}
            >
                <DataGrid
                    className="payrollGrid"
                    density="compact"
                    rows={accessChanges || []}
                    columns={schoolColumns()}
                    sx={{
                        color: "black", fontSize: "14px", fontWeight: "600",
                        "& .green-row": {
                            backgroundColor: "#a4f6a4b3 !important",
                        },
                        "& .green-row:hover": {
                            backgroundColor: "#a4f6a4b3 !important",
                        }
                    }}

                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    rowHeight={60}
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    getRowClassName={getRowClassName}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </DataGridContainer>
        </>
        );
    };

    async function getAllDropdowns() {

        let results = await window.Platform.database.getOlympiadDropdownData();

        if (results?.status) {
            setDropdownMediums(results?.data?.mediums)
            setDropdownOlympiadDates(results.data.olympiad_dates);
        }
    }

    return (
        <>
            <StaffEditorPageContainer>
                <HeaderContainer>
                    <Box sx={{ mt: 1, width: "100%" }}>
                        <Paper elevation={3}
                            sx={{
                                p: 2,
                                mb: 2,
                                width: '100%',        // takes full width of parent
                                // maxWidth: '1000px',   // optional: control max width
                                mx: 'auto',
                                backgroundColor: "#ebf0fa"          // center it horizontally
                            }}>
                            <div className="container-fluid" style={{ width: "100%" }}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                placeholder="Type To Search"
                                                label="Search By RNO ID, UserName/ ID, SchoolName/ ID"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)} // Proper event handler
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Search color="action" sx={{ color: "black" }} />
                                                        </InputAdornment>
                                                    ),
                                                    style: { color: "black", fontSize: "14px", fontWeight: "500" }
                                                }}
                                                InputLabelProps={{
                                                    style: { color: "black", fontSize: "14px" }, // Label color
                                                }}
                                            />
                                        </FormControl>
                                    </div>
                                    {userData?.role.includes('admin') && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select
                                                value={rsm}
                                                label="Select HO"
                                                size="small"
                                                onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rsms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select
                                                value={asm}
                                                label="Select ARM"
                                                size="small"
                                                onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {asms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                                            <Select
                                                value={rm}
                                                label="Select RM"
                                                size="small"
                                                onChange={(e) => { setRm(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Medium</InputLabel>
                                            <Select
                                                value={medium}
                                                label="Select Medium"
                                                size="small"
                                                sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                                onChange={(e) => { setMedium(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {dropdownMediums.map((ele, ind) => (
                                                    <MenuItem key={ind} value={ele.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{ele.medium_name} </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Olympiad Date</InputLabel>
                                            <Select
                                                value={olympiadDate}
                                                label="Select Olympiad Date"
                                                size="small"
                                                sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                                onChange={(e) => { setOlympiadDate(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {dropdownOlympiadDates.map((ele, ind) => (
                                                    <MenuItem key={ind} value={ele.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>
                                                        {/* {ele.exam_date} */}
                                                        {new Date(ele.exam_date).toLocaleDateString("en-GB")}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Transaction Status</InputLabel>
                                            <Select
                                                value={transactionVerifyStatus}
                                                label="Transaction Status"
                                                size="small"
                                                sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                                onChange={(e) => { setTransactionVerifyStatus(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                <MenuItem value="1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Matched</MenuItem>
                                                <MenuItem value="0" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Unmatched</MenuItem>
                                                {/* {dropdownMediums.map((ele, ind) => (
                                                    <MenuItem key={ind} value={ele.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{ele.medium_name} </MenuItem>
                                                ))} */}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }}
                                            onClick={() => { setHasSearched(true); fetchAllData(); }}
                                        >
                                            Find
                                        </Button>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" size="small" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilter()}>
                                            Clear Filters
                                        </Button>
                                    </div>
                                    {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <Button
                                                variant="contained"
                                                color="success"
                                                startIcon={<FileDownloadIcon />}
                                                onClick={handleDownloadExcel}
                                            >
                                                Download
                                            </Button>
                                        </FormControl>
                                    </div>}
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <FormControl fullWidth size="small">
                                            <Button
                                                variant="contained"
                                                color="success"
                                                startIcon={<FileDownloadIcon />}
                                                onClick={handleDownloadTransactionExcel}
                                            >
                                                Download Transaction
                                            </Button>
                                        </FormControl>}
                                    </div>
                                    <div className="col-md-3">
                                        {((userData?.role == "super admin") || (userData?.role.includes("finance")))  && <Button
                                            variant="contained"
                                            fullWidth
                                            color="primary"
                                            onClick={() => setBulkSchool(true)}
                                            sx={{ borderRadius: "10px" }}
                                        >
                                            <DriveFolderUploadIcon sx={{ mr: 1 }} />
                                            Bulk Add Transaction
                                        </Button>}
                                    </div>

                                    <div className="col-md-2">
                                        {(userData?.role == "super admin") && <Button
                                            variant="contained"
                                            fullWidth
                                            color="primary"
                                            onClick={() => setBulkSoBoModal(true)}
                                            sx={{ borderRadius: "10px" }}
                                        >
                                            <DriveFolderUploadIcon sx={{ mr: 1 }} />
                                            Bulk Add SO
                                        </Button>}
                                    </div>

                                    <div className="col-md-2">
                                        {(userData?.role == "super admin") && <Button
                                            variant="contained"
                                            fullWidth
                                            color="primary"
                                            onClick={() => setBulkInvoiceModal(true)}
                                            sx={{ borderRadius: "10px" }}
                                        >
                                            <DriveFolderUploadIcon sx={{ mr: 1 }} />
                                            Bulk SM Invoice
                                        </Button>}
                                    </div>
                                    <div className="col-md-2">
                                        {(userData?.role == "super admin") && <Button
                                            variant="contained"
                                            fullWidth
                                            color="primary"
                                            onClick={() => setBulkInvoiceModalRC(true)}
                                            sx={{ borderRadius: "10px" }}
                                        >
                                            <DriveFolderUploadIcon sx={{ mr: 1 }} />
                                            Bulk RC Invoice
                                        </Button>}
                                    </div>
                                </div>
                            </div>
                        </Paper>
                        <Box display="flex" justifyContent="space-between" gap={2}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 2,
                                    // py: 1,
                                    background: "#e8f5e9",
                                    border: "1px solid #a5d6a7",
                                    borderLeft: "4px solid #2e7d32",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                    width: "fit-content",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#1b5e20",
                                        letterSpacing: "0.3px",
                                    }}
                                >
                                    Total Entries:
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        color: "#2e7d32",
                                        background: "#fff",
                                        px: 1.2,
                                        // py: 0.2,
                                        borderRadius: "6px",
                                        border: "1px solid #a5d6a7",
                                        minWidth: "28px",
                                        textAlign: "center",
                                    }}
                                >
                                    {rowCount || 0}
                                </Typography>
                            </Box>

                            <Box gap={2} display={"flex"}>
                                  {/* <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>OTP Delivered</InputLabel>
                                            <Select
                                                value={otpDeliveredStatus}
                                                label="OTP Delivered"
                                                size="small"
                                                sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                                                onChange={(e) => { setOtpDeliveredStatus(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                <MenuItem value="yes" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>YES</MenuItem>
                                                <MenuItem value="no" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>NO</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div> */}
                                <Button variant="contained" color="info"
                                    onClick={() => { navigate("/setOffList"); }}>
                                    Set OFF ENTRIES
                                </Button>

                                {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <Button
                                    startIcon={<FileDownloadIcon />}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleDownloadAllImagesZip(accessChanges)}
                                >
                                    Download All Attachments
                                </Button>}

                                {accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&
                                    <Button variant="contained" color="primary"
                                        onClick={() => { setAddModal(true); setEditModalData(null); setEditMode(false); }}
                                        sx={{ mr: 1, borderRadius: '10px' }}
                                    >
                                        <Add sx={{ mr: 1 }} />
                                        Register New School
                                    </Button>
                                }
                                 {/* {((userData?.role.includes("admin"))) && <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setBulkMainRegistrationModalModal(true)}
                                            sx={{ borderRadius: "10px" }}
                                        >
                                            <DriveFolderUploadIcon sx={{ mr: 1 }} />
                                            Bulk Add Registration
                                        </Button>} */}
                            </Box>
                        </Box>
                    </Box>
                </HeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        {loading && <OpaqueLoading />}
                        {renderTabContent()}
                    </TabsContainer>
                </TableContainer>
            </StaffEditorPageContainer>

            {
                addModal && <AddOlympiadSchoolModal
                    onClose1={onClose}
                    partyS={'school'}
                    onClose={() => setAddModal(false)}
                    fetchData={() => fetchAllData()}
                    editMode={editMode}
                    dataProp={editModalData}
                />
            }

            <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewOlympiadRegistrationModal
                        closePopup={() => {
                            setOpenModal(false);
                            setViewOlympiadModalData(null);
                        }}
                        modalData={viewOlympiadModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={openModalWhenVerify} onClose={() => setOpenModalWhenVerify(false)} PaperProps={{ sx: { width: "600px", maxWidth: "600px" } }} >
                <DialogTitle>Please Verify Or Hold This</DialogTitle>{console.log(selectedRow, "selectedRowselectedRowselectedRow")}
                <DialogContent>
                   {selectedRow?.rno_id && <Typography>RNO ID: {selectedRow?.rno_id}</Typography>}
                   {selectedRow?.schoolName && <Typography>School Name: {selectedRow?.schoolName}</Typography>}
                </DialogContent>
                <DialogActions>
                     <Button variant="contained" color="warning" fullWidth onClick={() => setApproveModalHold(true)}>
                            On Hold
                        </Button>

                        <Button variant="contained" color="success" fullWidth onClick={() => setApproveModal(true)}>
                            Approve
                        </Button>
                </DialogActions>

                <DialogActions>
                    <Button onClick={() => setOpenModalWhenVerify(false)}>Cancel</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={approveModal} onClose={() => setApproveModal(false)} PaperProps={{ sx: { width: "600px", maxWidth: "600px" } }} >
                <DialogTitle>Approve Remark</DialogTitle>
                <DialogContent>
                    <TextField fullWidth label="Enter Remark" multiline rows={3}
                        value={approveRemark}
                        onChange={(e) => setApproveRemark(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setApproveModal(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            if (!approveRemark.trim()) {
                                window.NotificationUtils.showError("Remark is required");
                                return;
                            }
                            handleUpdateStatus(selectedRow, 1, approveRemark);
                            setApproveModal(false);
                            setApproveRemark("");
                            setOpenModalWhenVerify(false);
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={approveModalHold} onClose={() => setApproveModalHold(false)} PaperProps={{ sx: { width: "600px", maxWidth: "600px" } }} >
                <DialogTitle>Hold Remark</DialogTitle>
                <DialogContent>
                    <TextField fullWidth label="Enter Remark" multiline rows={3}
                        value={approveRemarkHold}
                        onChange={(e) => setApproveRemarkHold(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setApproveModalHold(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            if (!approveRemarkHold.trim()) {
                                window.NotificationUtils.showError("Remark is required");
                                return;
                            }
                            handleUpdateStatus(selectedRow, 9, approveRemarkHold);
                            setApproveModalHold(false);
                            setApproveRemarkHold("");
                            setOpenModalWhenVerify(false);
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={onHoldModal} onClose={() => setOnHoldModal(false)} PaperProps={{ sx: { width: "600px", maxWidth: "600px" } }} >
                <DialogTitle>On Hold Remark</DialogTitle>
                <DialogContent>
                    <TextField fullWidth label="Enter Remark" multiline rows={3}
                        value={onHoledRemark}
                        onChange={(e) => setOnHoldRemark(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOnHoldRemark(""); setOnHoldModal(false) }}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            if (!onHoledRemark.trim()) {
                                window.NotificationUtils.showError("Remark is required");
                                return;
                            }
                            handleOnHoldRegistration(onHoledRemark);
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={verifyModal} onClose={() => setVerifyModal(false)} PaperProps={{ sx: { width: "600px", maxWidth: "600px" } }} >
                <DialogTitle>Verify Remark</DialogTitle>
                <DialogContent>
                    <TextField fullWidth label="Enter Remark" multiline rows={3}
                        value={verifyRemark}
                        onChange={(e) => setVerifyRemark(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setVerifyRemark(""); setVerifyModal(false) }}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            if (!verifyRemark.trim()) {
                                window.NotificationUtils.showError("Remark is required");
                                return;
                            }
                            handleVerifyRegistration(verifyRemark);
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={rejectModal} onClose={() => setRejectModal(false)} PaperProps={{ sx: { width: "600px", maxWidth: "600px" } }} >
                <DialogTitle>Reject Remark</DialogTitle>
                <DialogContent>
                    <TextField fullWidth label="Enter Remark" multiline rows={3}
                        value={rejectRemark}
                        onChange={(e) => setRejectRemark(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRejectModal(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            if (!rejectRemark.trim()) {
                                window.NotificationUtils.showError("Remark is required");
                                return;
                            }
                            handleUpdateStatus(selectedRow, 6, rejectRemark);
                            setRejectModal(false);
                            setRejectRemark("");
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteModal} onClose={() => setDeleteModal(false)} PaperProps={{ sx: { width: "600px", maxWidth: "600px" } }} >
                <DialogTitle>Delete Remark</DialogTitle>
                <DialogContent>
                    <TextField fullWidth label="Enter Remark" multiline rows={3}
                        value={deleteRemark}
                        onChange={(e) => setDeleteRemark(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setDeleteRemark(""); setDeleteModal(false) }}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            if (!deleteRemark.trim()) {
                                window.NotificationUtils.showError("Remark is required");
                                return;
                            }
                            handleDeleteRemark(deleteRemark);
                        }}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={updatePaymentModal} onClose={() => setUpdatePaymentModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <SelectionPaymentOlympiad
                        closePopup={() => {
                            setUpdatePaymentModal(false);
                            setEditModalDataNew(null);
                            fetchAllData(); // Refresh data after payment update
                        }}
                        editData={editModalDataNew}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={addSoModal} onClose={() => setAddSoModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <AddSoOlympiad
                        closePopup={() => {
                            setAddSoModal(false);
                            setAddSoModalData(null);
                            fetchAllData();
                        }}
                        modalData={addSoModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewToVerifySoModal} onClose={() => setviewToVerifySoModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewToVerifySoOlympiad
                        closePopup={() => {
                            setviewToVerifySoModal(false);
                            setviewToVerifySoModalData(null);
                            fetchAllData();
                        }}
                        modalData={viewToVerifySoModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={addInvoiceModal} onClose={() => setAddInvoiceModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <AddInvoiceOlympiad
                        closePopup={() => {
                            setAddInvoiceModal(false);
                            setAddInvoiceModalData(null);
                            setInvoiceType(null);
                            fetchAllData();
                        }}
                        modalData={addInvoiceModalData}
                        invoiceType={invoiceType}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={addInvoiceModalRC} onClose={() => setAddInvoiceModalRC(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <AddInvoiceOlympiadRC
                        closePopup={() => {
                            setAddInvoiceModalRC(false);
                            setAddInvoiceModalDataRC(null);
                            setInvoiceType(null);
                            fetchAllData();
                        }}
                        modalData={addInvoiceModalDataRC}
                        invoiceType={invoiceType}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={addInvoiceModalSM} onClose={() => setAddInvoiceModalSM(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <AddInvoiceOlympiadSM
                        closePopup={() => {
                            setAddInvoiceModalSM(false);
                            setAddInvoiceModalDataSM(null);
                            setInvoiceType(null);
                            fetchAllData();
                        }}
                        modalData={addInvoiceModalDataSM}
                        invoiceType={invoiceType}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewToVerifyInvoiceModal} onClose={() => setviewToVerifyInvoiceModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewToVerifyInvoiceOlympiad
                        closePopup={() => {
                            setviewToVerifyInvoiceModal(false);
                            setviewToVerifyInvoiceModalData(null);
                            setVerifyInvoiceType(null);
                            fetchAllData();
                        }}
                        modalData={viewToVerifyInvoiceModalData}
                        invoiceType={verifyInvoiceType}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewToVerifyInvoiceModalRC} onClose={() => setviewToVerifyInvoiceModalRC(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewToVerifyInvoiceOlympiadRC
                        closePopup={() => {
                            setviewToVerifyInvoiceModalRC(false);
                            setviewToVerifyInvoiceModalDataRC(null);
                            setVerifyInvoiceType(null);
                            fetchAllData();
                        }}
                        modalData={viewToVerifyInvoiceModalDataRC}
                        invoiceType={verifyInvoiceType}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewToVerifyInvoiceModalSM} onClose={() => setviewToVerifyInvoiceModalSM(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewToVerifyInvoiceOlympiadSM
                        closePopup={() => {
                            setviewToVerifyInvoiceModalSM(false);
                            setviewToVerifyInvoiceModalDataSM(null);
                            setVerifyInvoiceType(null);
                            fetchAllData();
                        }}
                        modalData={viewToVerifyInvoiceModalDataSM}
                        invoiceType={verifyInvoiceType}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewInvoiceModal} onClose={() => setViewInvoiceModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewInvoiceOlympiad
                        closePopup={() => {
                            setViewInvoiceModal(false);
                            setViewInvoiceModalData(null);
                            fetchAllData();
                        }}
                        modalData={viewInvoiceModalData}
                    />
                </DialogContent>
            </Dialog>


            <Dialog open={addSetOffModal} onClose={() => setAddSetOffModal(false)} maxWidth="md" fullWidth>
                <DialogContent>
                    <AddSetOffOlympiad
                        closePopup={() => {
                            setAddSetOffModal(false);
                            setAddSetOffModalData(null);
                            fetchAllData();
                        }}
                        modalData={addSetOffModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewSoImageModal} onClose={() => setViewSoImageModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewSoImageModal
                        closePopup={() => {
                            setViewSoImageModal(false);
                            setViewSoImageModalData(null);
                        }}
                        modalData={viewSoImageModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewSMInvoiceImageModal} onClose={() => setViewSMInvoiceImageModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewSMInvoiceImageModal
                        closePopup={() => {
                            setViewSMInvoiceImageModal(false);
                            setViewSMInvoiceImageModalData(null);
                        }}
                        modalData={viewSMInvoiceImageModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={viewRCInvoiceImageModal} onClose={() => setViewRCInvoiceImageModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <ViewRCInvoiceImageModal
                        closePopup={() => {
                            setViewRCInvoiceImageModal(false);
                            setViewRCInvoiceImageModalData(null);
                        }}
                        modalData={viewRCInvoiceImageModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={verifyPaymentModal} onClose={() => setVerifyPaymentModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <VerifyPaymentOlympiadRegistrationModal
                        closePopup={() => {
                            setVerifyPaymentModal(false);
                            setVerifyPaymentModalData(null);
                            fetchAllData();
                        }}
                        modalData={verifyPaymentModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={shipmentModal} onClose={() => setShipmentModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <OlympiadShipmentModal
                        closePopup={() => {
                            setShipmentModal(false);
                            setShipmentModalData(null);
                            fetchAllData();
                        }}
                        modalData={shipmentModalData}
                    />
                </DialogContent>
            </Dialog>

            <Dialog open={deliverModal} onClose={() => setDeliverModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <OlympiadDeliverModal
                        closePopup={() => {
                            setDeliverModal(false);
                            setDeliverModalData(null);
                            fetchAllData();
                        }}
                        modalData={deliverModalData}
                    />
                </DialogContent>
            </Dialog>
            <Dialog open={itemDeliverModal} onClose={() => setItemDeliverModal(false)} maxWidth="lg" fullWidth>
                <DialogContent>
                    <OlympiadItemDeliverModal
                        closePopup={() => {
                            setItemDeliverModal(false);
                            setItemDeliverModalData(null);
                            fetchAllData();
                        }}
                        modalData={itemDeliverModalData}
                    />
                </DialogContent>
            </Dialog>

            {bulkSchool && (
                <BulkOlympiadTransaction
                    onClose={() => setBulkSchool(false)}
                    fetchData={() => fetchAllData()}
                />
            )}

            {bulkSoBoModal && (
                <BulkAddSoBoOlympiad
                    onClose={() => setBulkSoBoModal(false)}
                    fetchData={() => fetchAllData()}
                />
            )}

            {bulkInvoiceModal && (
                <BulkAddInvoiceOlympiadSM
                    onClose={() => setBulkInvoiceModal(false)}
                    fetchData={() => fetchAllData()}
                />
            )}
            {bulkInvoiceModalRC && (
                <BulkAddInvoiceOlympiadRC
                    onClose={() => setBulkInvoiceModalRC(false)}
                    fetchData={() => fetchAllData()}
                />
            )}

            {bulkMainRegistrationModal && (
                <BulkAddMainRegistration
                    onClose={() => setBulkMainRegistrationModalModal(false)}
                    fetchData={() => fetchAllData()}
                />
            )}

            <Dialog
                open={newVerify}
                // onClose={closePopup}
                fullWidth
                maxWidth="lg"
            >
                {/* HEADER */}
                <DialogTitle sx={{ pr: 6 }}>
                    <b>Olympiad Details: - </b> {viewOlympiadModalData?.schoolName} ({viewOlympiadModalData?.partyId})

                    <IconButton
                        onClick={() => setNewVerify(false)}
                        sx={{ position: "absolute", right: 10, top: 10 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>

                    {/* 🔹 Coordinators */}
                    <Box mb={3}>
                        <Typography variant="h6" mb={1}>
                            Coordinator Details
                        </Typography>

                        <Table size="small">
                            <TableHead sx={{ backgroundColor: "#1976d2" }}>
                                <TableRow>
                                    <TableCell sx={{ color: "#fff" }}><b>S.No</b></TableCell>
                                    <TableCell sx={{ color: "#fff" }}><b>Subject</b></TableCell>
                                    <TableCell sx={{ color: "#fff" }}><b>Coordinator Name</b></TableCell>
                                    <TableCell sx={{ color: "#fff" }}><b>Mobile</b></TableCell>
                                    <TableCell sx={{ color: "#fff" }}><b>Email</b></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {viewOlympiadModalData?.coordinators?.length > 0 ? (
                                    viewOlympiadModalData.coordinators.map((c, i) => (
                                        <TableRow key={c.id}>
                                            <TableCell>{i + 1}</TableCell>
                                            <TableCell>{c.subject_name}</TableCell>
                                            <TableCell>{c.name}</TableCell>
                                            <TableCell>{c.mobile}</TableCell>
                                            <TableCell>{c.email}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No Coordinator Found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    {/* 🔹 Line Items */}
                    <Grid container spacing={2}>
                        {Object.entries(groupedSubjects || {}).map(([subject, items], idx) => {

                            const totalRegAmount = items.reduce(
                                (sum, i) => sum + ((i.student || 0) * (i.registrationFee || 0)),
                                0
                            );

                            const totalSMCount = items.reduce(
                                (sum, i) => sum + (Number(i.study_material) || 0),
                                0
                            );

                            const totalSMAmount = items.reduce(
                                (sum, i) =>
                                    sum + ((Number(i.study_material) || 0) * (Number(i.subjectAmount) || 0)),
                                0
                            );

                            const grandTotal = totalRegAmount + totalSMAmount;
                            const totalStudents = items.reduce((sum, i) => sum + (Number(i.student) || 0), 0);

                            return (
                                <Grid item xs={12} key={idx}>
                                    <Card>
                                        <CardContent>

                                            <Typography variant="h6" mb={1}>
                                                Subject: {subject}
                                            </Typography>

                                            <Table size="small">
                                                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                                                    <TableRow>
                                                        <TableCell sx={{ color: "#fff" }}>Class</TableCell>
                                                        <TableCell sx={{ color: "#fff" }}>Students</TableCell>
                                                        <TableCell sx={{ color: "#fff" }}>Registration Fee</TableCell>
                                                        <TableCell sx={{ color: "#fff" }}>Study Material</TableCell>
                                                        <TableCell sx={{ color: "#fff" }}>SM Count</TableCell>
                                                        <TableCell sx={{ color: "#fff" }}>SM Fee</TableCell>
                                                        <TableCell sx={{ color: "#fff" }}>Amount</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {/* {items.map((item, i) => { */}
                                                    {[...items]
                                                        .sort((a, b) => getClassNumber(a.className) - getClassNumber(b.className))
                                                        .map((item, i) => {
                                                            // const regAmount = (item.student || 0) * (item.registrationFee || 0);
                                                            // const smCount = item.study_material ? item.student : 0;
                                                            // const smAmount = smCount * (item.subjectAmount || 0);
                                                            // const totalAmount = regAmount + smAmount;
                                                            const regAmount = (Number(item.student) || 0) * (Number(item.registrationFee) || 0);
                                                            const smCount = Number(item.study_material) || 0;
                                                            const smAmount = smCount * (Number(item.subjectAmount) || 0);
                                                            const totalAmount = regAmount + smAmount;

                                                            return (
                                                                <TableRow key={i}>
                                                                    <TableCell>{item.className}</TableCell>
                                                                    <TableCell>{item.student}</TableCell>
                                                                    <TableCell>₹{regAmount}</TableCell>
                                                                    <TableCell>
                                                                        <Chip
                                                                            label={item.study_material ? "Yes" : "No"}
                                                                            size="small"
                                                                            color={item.study_material ? "success" : "default"}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell>{smCount}</TableCell>
                                                                    <TableCell>₹{smAmount}</TableCell>
                                                                    <TableCell><b>₹{totalAmount}</b></TableCell>
                                                                </TableRow>
                                                            );
                                                        })}

                                                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                                        <TableCell><b>Total</b></TableCell>
                                                        <TableCell><b>{totalStudents}</b></TableCell>
                                                        <TableCell><b>₹{totalRegAmount}</b></TableCell>
                                                        <TableCell />
                                                        <TableCell><b>{totalSMCount}</b></TableCell>
                                                        <TableCell><b>₹{totalSMAmount}</b></TableCell>
                                                        <TableCell><b>₹{grandTotal}</b></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>

                                        </CardContent>
                                    </Card>
                                </Grid>
                            );
                        })}
                    </Grid>
                    <Box mt={2} sx={{ display: "flex", justifyContent: "space-between", gap: 5 }}>
                        {((userData?.role.includes("admin") && accessModulesData?.[0]?.onHold?.toLowerCase() == "yes") || userData?.role == "super admin") && (newOrderStatus == 0 || newOrderStatus == 10) && <Button variant="contained" color="warning" fullWidth onClick={() => handleOnholdFunc(viewOlympiadModalData)}>
                            On Hold
                        </Button>}
                        {((userData?.role.includes("admin") && accessModulesData?.[0]?.verify?.toLowerCase() == "yes") || userData?.role == "super admin") && <Button variant="contained" color="success" fullWidth onClick={() => handleVerifyFunc(viewOlympiadModalData)}>
                            Verify
                        </Button>}
                    </Box>

                </DialogContent>
            </Dialog>

            <Dialog
                open={viewValueModal}
                onClose={closeViewValueModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "20px",
                        color: "#000",
                        fontWeight: 600,
                    }}
                >
                    RM Remark

                    <IconButton onClick={closeViewValueModal}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent style={{ borderTop: "1px solid #000" }}>
                    <Typography sx={{ fontSize: "15px", color: "#000", fontWeight: 500, marginTop: "10px" }}>
                        {viewValue || "No Remark Available"}
                    </Typography>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default OlympiadRegistration;
